// extracted by mini-css-extract-plugin
export default {"details":"AboutBox_details__S6pDj","detail-box":"AboutBox_detail-box__ewl7K"};